
import { UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Organization } from "@/types/subscription";
import { PendingInvitation } from "@/hooks/useUserInvitation";

import InvitationSteps from "./InvitationSteps";
import DemoModeAlert from "./DemoModeAlert";
import OrganizationSelector from "./OrganizationSelector";
import RemainingInvitesInfo from "./RemainingInvitesInfo";
import EmailInputSection from "./EmailInputSection";
import PendingInvitationsList from "./PendingInvitationsList";

interface InvitationFormProps {
  organizations: Organization[];
  selectedOrgId: string;
  onSelectOrg: (orgId: string) => void;
  isLoading: boolean;
  selectedOrg: Organization | null;
  remainingInvites: number;
  emailList: string[];
  setEmailList: (emails: string[]) => void;
  pendingInvites: PendingInvitation[];
  handleSubmitInvitations: () => Promise<void>;
}

const InvitationForm = ({
  organizations,
  selectedOrgId,
  onSelectOrg,
  isLoading,
  selectedOrg,
  remainingInvites,
  emailList,
  setEmailList,
  pendingInvites,
  handleSubmitInvitations
}: InvitationFormProps) => {
  return (
    <div className="bg-white dark:bg-[#1a1d2d] rounded-lg border border-gray-200 dark:border-gray-800 shadow-sm p-6">
      <DemoModeAlert />

      <OrganizationSelector
        organizations={organizations}
        selectedOrgId={selectedOrgId}
        onSelect={onSelectOrg}
        isLoading={isLoading}
      />

      <h2 className="text-lg font-semibold mb-4 dark:text-gray-100">Qui souhaiteriez-vous inviter?</h2>
      
      <RemainingInvitesInfo 
        remainingInvites={remainingInvites} 
        selectedOrg={selectedOrg} 
      />

      <EmailInputSection
        emailList={emailList}
        setEmailList={setEmailList}
        remainingInvites={remainingInvites}
        isLoading={isLoading}
        selectedOrgId={selectedOrgId}
        pendingInvites={pendingInvites}
      />

      <div className="flex justify-end mt-6">
        <Button
          onClick={handleSubmitInvitations}
          className="bg-blue-500 hover:bg-blue-600 text-white flex items-center gap-2"
          disabled={emailList.length === 0 || isLoading || remainingInvites === 0 || !selectedOrgId}
        >
          <UserPlus className="h-4 w-4" />
          {isLoading ? "Envoi en cours..." : "Envoyer les invitations"}
        </Button>
      </div>

      <PendingInvitationsList pendingInvites={pendingInvites} />
    </div>
  );
};

export default InvitationForm;
